import ApiUrl from './api';

// Keeps the cached user in localStorage honest about role and permissions.
//
// Why this is needed: login is the ONLY place that writes "user-info", so once a lab owner
// changes an employee's access the employee's browser keeps the old permission list until they
// sign out. That is fine for security - the API enforces permissions on every request
// regardless - but it means the sidebar would show pages that now fail with 403.
//
// Why it reloads: about 40 modules do `const User = JSON.parse(localStorage.getItem(...))` at
// module scope, evaluated once on import. Rewriting localStorage does not reach any of them, so
// a reload is the only way to make a change take effect. It is therefore done ONLY when
// something actually differs, or every page load would loop.
const sameAccess = (a, b) => {
    if (!a || !b) return false;
    if (a.role !== b.role) return false;
    const pa = Array.isArray(a.permissions) ? [...a.permissions].sort() : [];
    const pb = Array.isArray(b.permissions) ? [...b.permissions].sort() : [];
    return pa.length === pb.length && pa.every((k, i) => k === pb[i]);
};

export const refreshUserInfo = () => {
    let stored = null;
    try { stored = JSON.parse(localStorage.getItem("user-info")); } catch (e) { return; }
    if (!stored || !stored.token) return;

    fetch(ApiUrl.OAuth_UserInfo, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + stored.token
        }
    })
    .then((res) => res.ok ? res.json() : null)
    .then((data) => {
        if (!data || !data.success || !data.responce) return;
        const fresh = data.responce;
        if (sameAccess(stored, fresh)) return;
        // The endpoint returns the same shape login does, but keep the stored token: the column
        // holds whatever was last issued and overwriting it with a stale value would sign the
        // user out.
        localStorage.setItem("user-info", JSON.stringify({ ...fresh, token: stored.token }));
        document.location.reload();
    })
    // Offline or a failed request must not break the page - the cached user stays as it was.
    // A 401 is not one of those cases and never reaches here: configTools/authGuard.js sees it
    // first and signs the user out.
    .catch(() => {});
};
